// extracted by mini-css-extract-plugin
module.exports = {"guestPayWrapper":"MakePaymentContainer_guestPayWrapper__2VO6S"};